/** Reads one search param as a string; the router parses numeric-looking values as numbers. */
export function searchString(value: unknown): string | undefined {
  return typeof value === "string" || typeof value === "number" ? String(value) : undefined;
}

/** Place codes as the booking API accepts them. */
export const placeCodePattern = /^[A-Z0-9-]{2,32}$/;
